export const FormHandler = () => {
  let a;
  let allow;
  let form_fields = [
    'pass_port',
    'name',
    'dob',
    'father_name',
    'file_no',
    'address'
  ];
  function required(name) {
    a = document.getElementById(name);
    if (!a.value) {
      a.parentNode.parentNode.style.borderColor = 'red';
      a.parentNode.parentNode.parentNode.children[1].innerHTML = 'Required';
      a.parentNode.parentNode.parentNode.children[1].style.visibility =
        'visible';
      allow = false;
    }
  }
  function max_digit(name, max_digit) {
    a = document.getElementById(name);
    if (a.value && a.value.length > max_digit) {
      a.parentNode.parentNode.style.borderColor = 'red';
      a.parentNode.parentNode.parentNode.children[1].innerHTML =
        'Should be lessetr than ' + max_digit;
      a.parentNode.parentNode.parentNode.children[1].style.visibility =
        'visible';
      allow = false;
    }
  }
  for (let i = 0; i <= form_fields.length; i++) {
    if (form_fields[i] == 'pass_port') {
      required(form_fields[i]);
    }
    if (form_fields[i] == 'name') {
      required(form_fields[i]);
    }
    if (form_fields[i] == 'dob') {
      required(form_fields[i]);
    }
    if (form_fields[i] == 'father_name') {
      required(form_fields[i]);
    }
    if (form_fields[i] == 'file_no') {
      required(form_fields[i]);
    }
    if (form_fields[i] == 'address') {
      required(form_fields[i]);
    }
  }
  if (allow) {
    // alert('success')
  }
};
